import { render, staticRenderFns } from "./IconCoinUp.vue?vue&type=template&id=1426abf7&scoped=true&"
import script from "./IconCoinUp.vue?vue&type=script&lang=js&"
export * from "./IconCoinUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426abf7",
  null
  
)

export default component.exports